import { z } from 'zod';

import { urlWithoutHttpsRegex } from '../../../helpers/stringHelpers';

export const schema = z.object({
  ticketshopLink: z.union([
    z.literal(''),
    z
      .string()
      .trim()
      .refine((value) => urlWithoutHttpsRegex.test(value), {
        message: 'url-format',
      }),
  ]),
  websiteLink: z.union([
    z.literal(''),
    z
      .string()
      .trim()
      .refine(
        (value) => urlWithoutHttpsRegex.test(value), // Use the same regex here
        {
          message: 'url-format',
        },
      ),
  ]),
  instagramLink: z.union([
    z.literal(''),
    z
      .string()
      .trim()
      .refine(
        (value) => urlWithoutHttpsRegex.test(value), // Apply regex for Instagram
        {
          message: 'url-format',
        },
      ),
  ]),
  tiktokLink: z.union([
    z.literal(''),
    z
      .string()
      .trim()
      .refine(
        (value) => urlWithoutHttpsRegex.test(value), // Apply regex for TikTok
        {
          message: 'url-format',
        },
      ),
  ]),
  spotifyLink: z.union([
    z.literal(''),
    z
      .string()
      .trim()
      .refine(
        (value) => urlWithoutHttpsRegex.test(value), // Apply regex for Spotify
        {
          message: 'url-format',
        },
      ),
  ]),
});
